export { default } from "./MainHeaderContent";
